'use client';

import { Box } from 'ui/components/box';
import { Button } from 'ui/components/button';
import { ControlledButton } from 'ui/components/controlled-button';
import { Link } from 'ui/components/link';
import { Progress } from 'ui/components/progress';
import { getUrl } from 'ui/utils/get-url';
import { useAuth } from 'ui/providers/auth-provider';

export default function LoginPage() {
  const auth = useAuth();

  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '4',
        minHeight: '50vh',
        '& > *': { width: '15rem' },
      }}
    >
      {auth.isLoading ? (
        <Box css={{ width: '4rem' }}>
          <Progress type='circular' />
        </Box>
      ) : (
        <>
          <Link buttonVariant='filled' href={getUrl('/user/login/email')}>
            Log In With Email
          </Link>

          <ControlledButton onClick={() => auth.signInWithGoogle()} variant='tonal'>
            Log In With Google
          </ControlledButton>
        </>
      )}
    </Box>
  );
}
